module.exports = __webpack_public_path__ + "static/media/bolt-icon.0056a6ca.svg";